/**
 * Where the SDK talks to when nobody tells it otherwise.
 *
 * WHY THIS IS A CONSTANT AND NOT TWO LITERALS
 *
 * It used to be two literals — one in browser auto-init, one in the editor
 * bootstrap — and both said `https://api.lionrapid.com`, a host that has NEVER
 * had a DNS record. Every bare-snippet install therefore resolved to NXDOMAIN,
 * and so did the editor. The published README documented the same dead host as
 * the escape hatch, so a user who set the attribute by hand failed in exactly
 * the same way as one who omitted it: there was no path to a working default.
 *
 * The API is served by `app.lionrapid.com` — verified, not assumed:
 * `app.lionrapid.com/api/health` answers 401 (auth required, endpoint present)
 * while `api.lionrapid.com` fails to resolve at all.
 *
 * WHY A DEFAULT AT ALL, given the CLI refuses to invent one
 *
 * The CLI's rule is right for the CLI and does not transfer. `requireInteractive`
 * exists because the CLI PERSISTS what it invents into `lionrapid.yml`, which is
 * committed and outlives the moment — an invented value there is unrecoverable
 * because nobody can later tell it apart from a chosen one. A browser default
 * persists nothing: it lives for one page load, in front of the developer who
 * just pasted the snippet, and is contradicted by the next attribute they add.
 *
 * Requiring the attribute would also not have prevented this bug. The README's
 * escape hatch named the same dead host, so a mandatory `data-base-url` copied
 * from our own docs fails identically. What prevents it is a default that is
 * checked, which is what `api-default.unit.test.ts` now does.
 *
 * MOVING THE API: change this constant, change the `data-base-url` examples in
 * the published READMEs, and the guard test will tell you if you missed one.
 */
export const DEFAULT_API_BASE_URL = 'https://app.lionrapid.com';
